import { useCallback } from 'react'
import DialogButton from '../../Common/Buttons/DialogButton'
import Dialog from '../../Common/Dialog/Dialog'
import DialogActions from '../../Common/Dialog/DialogActions'
import DialogContent from '../../Common/Dialog/DialogContent'
import DialogTitle from '../../Common/Dialog/DialogTitle'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch'
import { type BrandingOptionStore } from '../../UserData/_stores/BrandingOptionStore'
import { DeleteBrandingOption } from '../../UserData/_actions/BrandingOptionActions'

interface Props {
  brandingOption: BrandingOptionStore
  opened: boolean
  onClose: () => void
}

export default function DeleteBrandingOptionDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()

  const onConfirm = useCallback(() => {
    dispatch(DeleteBrandingOption(props.brandingOption.get('id')).set({
      onSuccess: () => props.onClose()
    }))
  }, [props.brandingOption, props.onClose])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{t('Delete branding option "{{name}}"', { name: props.brandingOption.get('name') })}</DialogTitle>
    <DialogContent>
      <p>{t('Are you sure that you want to delete this branding option?')}</p>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="error"
        onClick={onConfirm}
        autoFocus
      >{t('Delete')}</DialogButton>
    </DialogActions>
  </Dialog>
}
